import {readonly, type, TypeOf} from 'io-ts';
import {TransactionIdIoTs} from '~/library/types';

export type Transaction = TypeOf<typeof Transaction>;
export const Transaction = readonly(
    type({
        id: TransactionIdIoTs,
    })
);
